module.exports = __webpack_public_path__ + "img/logo_general.a7f1e9e3.png";